export default "/images/4ad3e50aa02ab62ab0965965bde1afdd.avif";